import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FusePageCarded } from '@fuse';
import { Icon, Button, IconButton } from '@material-ui/core';
import ReactTable from "react-table";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import * as Actions from './store/actions';
import * as TableActions from 'main/components/tableSort/store/actions';
import _ from 'lodash';
import TableCellTooltip from '../../components/TableCellTooltip';

const styles = theme => ({
    layoutRoot: {},
});

class StudentLessonList extends Component {

    constructor(props) {
        super(props);
        this.props.getLessonList(this.props.auth.user.data.role_info.link_id, 'all');
    }

    handleRowClick(lesson_id) {
        this.props.history.push(`/lesson/detail/${lesson_id}`);
    }

    timeColumn = (a) => {
        if (a.Unscheduled === 1) {
            return null
        }
        else {
            return moment(a.start).format('YYYY-MM-DD')
        }
    }

    render() {
        const { classes, lessonList, table_sort, table_filter, table_page_size, is_loaded } = this.props;
        const table_name = this.constructor.name;

        if (!is_loaded) return <React.Fragment>Loading...</React.Fragment>;
        
        return (
            <FusePageCarded
                classes={{
                    root: classes.layoutRoot
                }}
                header={
                    <div className="p-24"><h4>Lesson List</h4></div>
                }
                contentToolbar={
                    <div className="px-24 flex flex-1 justify-end">

                    </div>
                }
                content={
                    <ReactTable
                        columns={[
                            {
                                Header: "Lesson Name",
                                accessor: "title",
                                Cell: row => (
                                    <TableCellTooltip
                                        item={row.original.title}
                                        chars={20}
                                    />
                                )
                            },
                            {
                                Header: "Course Name",
                                accessor: "courseName",
                                Cell: row => (
                                    <TableCellTooltip
                                        item={row.original.courseName}
                                        chars={20}
                                    />
                                )
                            },
                            {
                                Header: "Date",
                                accessor: a => this.timeColumn(a),
                                sortMethod: (a, b) => {
                                    return moment(a, 'MMM Do YYYY, hh:mm A') > moment(b, 'MMM Do YYYY, hh:mm A') ? 1 : -1;
                                },
                                id: 'Date'
                            },
                            {
                                Header: "",
                                Cell: row => (
                                    <div className="flex items-center">
                                        <IconButton
                                            style={{ padding: '0px', marginLeft: '5px', marginRight: '5px' }}
                                            onClick={(ev) => {
                                                ev.stopPropagation();
                                                this.handleRowClick(row.original.lesson_id);
                                            }}
                                        >
                                            <Icon>library_books</Icon>
                                        </IconButton>
                                    </div>
                                )
                            }
                        ]}
                        data={lessonList}
                        defaultPageSize={25}
                        pageSize={table_page_size[table_name]}
                        className="-striped -highlight"
                        noDataText="No Lessons Found"
                        defaultSorted={table_sort[table_name]}
                        onSortedChange={(sort_list) => this.props.setTableSort(this.props.auth.user.data.auth_id, table_name, sort_list)}
                        filterable={true}
                        defaultFiltered={table_filter[table_name]}
                        onFilteredChange={_.debounce((filter_list) => this.props.setTableFilter(this.props.auth.user.data.auth_id, table_name, filter_list), 500)}
                        onPageSizeChange={(page_size) => this.props.setTablePageSize(this.props.auth.user.data.auth_id, table_name, page_size)}
                    />
                }
            />
        );
    }


}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getLessonList:    Actions.getStudentSchedule,
        setTableSort:     TableActions.setTableSort,
        setTableFilter:   TableActions.setTableFilter,
        resetTableFilter: TableActions.resetTableFilter,
        setTablePageSize: TableActions.setTablePageSize,

    }, dispatch);
}

function mapStateToProps({ studentApp, tableSort, auth }) {
    return {
        lessonList:      studentApp.students.events,
        table_sort:      tableSort.table_sort,
        table_filter:    tableSort.table_filter,
        table_page_size: tableSort.table_page_size,
        is_loaded:       tableSort.is_loaded,
        auth
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(StudentLessonList)));


// WEBPACK FOOTER //
// src/main/content/student/StudentLessonList.js